import { render, staticRenderFns } from "./mo-multiselect-wrapper.html?vue&type=template&id=e5a136d6&external"
import script from "./mo-multiselect-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./mo-multiselect-wrapper.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-multiselect-wrapper.vue?vue&type=style&index=0&id=e5a136d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports